(() => {
  const giftOffer = document.querySelector('[data-onlyfinds-gift-offer]');

  const giftVariantId = giftOffer ? Number(giftOffer.dataset.giftVariantId) : null;
  const parentVariantId = giftOffer ? Number(giftOffer.dataset.parentVariantId) : null;

  if (giftVariantId && parentVariantId) {
    localStorage.setItem(
      'onlyfinds_gift_map',
      JSON.stringify({
        parentVariantId,
        giftVariantId
      })
    );
  }

  function getGiftMap() {
    try {
      return JSON.parse(localStorage.getItem('onlyfinds_gift_map'));
    } catch {
      return null;
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function refreshCartUI() {
  document.dispatchEvent(new CustomEvent('cart:updated'));
  document.dispatchEvent(new CustomEvent('cart:refresh'));

  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
}
function showGiftPopup() {
  const popup = document.getElementById('OnlyFindsGiftPopup');

  if (!popup) return;

  popup.classList.add('is-visible');

  setTimeout(() => {
    popup.classList.remove('is-visible');
  }, 2500);
}
  async function addGiftToCart(quantity) {
    const map = getGiftMap();
    if (!map) return;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: map.giftVariantId,
          quantity,
          properties: {
            _onlyfinds_gift: 'true',
            _onlyfinds_parent_variant_id: String(map.parentVariantId)
          }
        }]
      })
    });
    showGiftPopup();

return response;
  }

  async function syncGiftCart() {
    const map = getGiftMap();
    if (!map) return;

    const cart = await getCart();

    const parentQty = cart.items
      .filter((item) => item.variant_id === map.parentVariantId)
      .reduce((sum, item) => sum + item.quantity, 0);

    const giftItems = cart.items.filter((item) =>
      item.variant_id === map.giftVariantId &&
      item.properties &&
      item.properties._onlyfinds_gift === 'true' &&
      item.properties._onlyfinds_parent_variant_id === String(map.parentVariantId)
    );

    const giftQty = giftItems.reduce((sum, item) => sum + item.quantity, 0);

    if (parentQty === 0 && giftItems.length > 0) {
      const updates = {};
      giftItems.forEach((item) => {
        updates[item.key] = 0;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });

      refreshCartUI();
      return;
    }

    if (parentQty > 0 && giftQty === 0) {
      await addGiftToCart(parentQty);
      refreshCartUI();
      return;
    }

    if (parentQty > 0 && giftQty !== parentQty && giftItems.length > 0) {
      const updates = {};

      giftItems.forEach((item, index) => {
        updates[item.key] = index === 0 ? parentQty : 0;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });

      refreshCartUI();
    }
  }

  function scheduleSync() {
  setTimeout(syncGiftCart, 800);
  setTimeout(syncGiftCart, 2000);
  setTimeout(syncGiftCart, 4000);
}

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    setTimeout(async () => {
      await syncGiftCart();
      refreshCartUI();
    }, 700);
  });

  document.addEventListener('click', scheduleSync);
  document.addEventListener('change', scheduleSync);

  setTimeout(syncGiftCart, 1000);
})();